import appraisalPort from "apis/appraisalPort";
import {
  REQUEST_APPRAISAL_PORT_HOLD_REASONS,
  RECEIVE_APPRAISAL_PORT_HOLD_REASONS,
  ERROR_APPRAISAL_PORT_HOLD_REASONS
} from "typeConstants";
import { WebApiReduxRequest } from "tools/webservice";

export const getOnHoldReasons = () => WebApiReduxRequest(
  REQUEST_APPRAISAL_PORT_HOLD_REASONS,
  RECEIVE_APPRAISAL_PORT_HOLD_REASONS,
  ERROR_APPRAISAL_PORT_HOLD_REASONS,
  "GET",
  appraisalPort.holdReasons()
);
